// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

const { debounce } = window.BAO.Utils

class ParallaxCollectionCards extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()
    if (!this.carousel) this.carousel = this.initialiseCarousel()
    this.setupParallax()
  }

  setupParallax () {
    if (!this.hasAttribute('data-parallax-hero')) return

    if (window.Shopify?.designMode) return

    const section = this.closest('.shopify-section')
    const hero = section?.previousElementSibling
    if (!section || !hero) return

    if (section.parentElement?.hasAttribute('data-parallax-wrapper')) return

    const wrapper = document.createElement('div')
    wrapper.className = 'sec-ParallaxCards_ParallaxWrapper'
    wrapper.setAttribute('data-parallax-wrapper', '')

    hero.before(wrapper)
    wrapper.append(hero, section)

    hero.classList.add('sec-ParallaxCards-parallaxHero')
    section.classList.add('sec-ParallaxCards-parallax')

    this.restoreListeners(wrapper)
  }

  restoreListeners (wrapper) {
    wrapper.querySelectorAll('*').forEach(element => {
      if (!element.listeners || typeof element.setupListeners !== 'function') {
        return
      }

      element.listeners.removeAll()
      element.setupListeners()
    })
  }

  setupListeners () {
    this.reinitCarousel = this.reinitCarousel.bind(this)
    this.listeners.add(window, 'resize', debounce(this.reinitCarousel, 250))
  }

  get itemCount () {
    return Number(this.dataset.items) || this.els?.slide?.elements?.length || 0
  }

  get gridBreakpoint () {
    return this.itemCount <= 2 ? 768 : 901
  }

  reinitCarousel () {
    const shouldRun = window.innerWidth < this.gridBreakpoint
    const isRunning = Boolean(this.carousel)
    if (shouldRun === isRunning) return

    if (isRunning) {
      this.carousel.destroy()
      this.carousel = null
      this.initialised = false
    } else {
      this.carousel = this.initialiseCarousel()
      super.reinitialise()
    }
  }

  initialiseCarousel () {
    if (
      !this.els?.slides?.exists ||
      !this.els?.slide?.exists ||
      window.innerWidth >= this.gridBreakpoint
    ) {
      return
    }

    const breakpoints =
      this.itemCount <= 2
        ? { '(min-width: 768px)': { disabled: true } }
        : {
            '(min-width: 768px)': {
              slides: { origin: 'auto', perView: 2.2, spacing: 15 },
            },
            '(min-width: 901px)': { disabled: true },
          }

    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      rubberband: true,
      slides: {
        origin: 'auto',
        perView: 1.15,
        spacing: 10,
      },
      breakpoints,
    })
  }
}

if (!customElements.get('parallax-collection-cards')) {
  customElements.define('parallax-collection-cards', ParallaxCollectionCards)
}
